import * as React from 'react';
import {Basic} from './Basic.story';
import {Disabled} from './Disabled.story';
import {Small} from './Small.story';

const basic = {
  rendered: <Basic />,
  source: `<Tabs fitted>
    <TabList>
      {[1, 2].map((i) => (
        <Tab key={i}>Tab {i}</Tab>
      ))}
    </TabList>
    <TabPanels>
      {[1, 2].map((i) => (
        <TabPanel key={i}>
          <ExamplePanel>Tab panel {i}</ExamplePanel>
        </TabPanel>
      ))}
    </TabPanels>
  </Tabs>`,
};
const disabled = {
  rendered: <Disabled />,
  source: `<Tabs size="large" fitted>
    <TabList>
      <Tab>Tab</Tab>
      <Tab>Another Tab</Tab>
      <Tab disabled>Disabled Tab</Tab>
    </TabList>
    <TabPanels>
      <TabPanel>
        <ExamplePanel>Test Tab Panel 1</ExamplePanel>
      </TabPanel>
      <TabPanel>
        <ExamplePanel>Test Tab Panel 2</ExamplePanel>
      </TabPanel>
      <TabPanel>
        <ExamplePanel>Test Tab Panel 3</ExamplePanel>
      </TabPanel>
    </TabPanels>
  </Tabs>`,
};
const small = {
  rendered: <Small />,
  source: `<Tabs size="small" selectedKey={key} onSelectionChange={setSelectedKey}>
    <TabList>
      {[1, 2, 3, 4, 5].map((i) => (
        <Tab key={i}>Tab {i}</Tab>
      ))}
    </TabList>
    <TabPanels>
      {[1, 2, 3, 4, 5].map((i) => (
        <TabPanel key={i}>
          <ExamplePanel>Tab panel {i}</ExamplePanel>
        </TabPanel>
      ))}
    </TabPanels>
  </Tabs>`,
};

export const TabsExamples = {
  basic,
  small,
  disabled,
};
